import React from "react";
import { motion } from "framer-motion";

const historyData = [
  { year: "1972", event: "Company Founded with a Vision.", image: "https://img.freepik.com/free-photo/3d-rendering-house-model_23-2150799663.jpg?ga=GA1.1.363961418.1739264693&semt=ais_authors_boost" },
  { year: "1999", event: "Expanded into New Markets.", image: "https://img.freepik.com/free-photo/low-angle-view-skyscrapers_1359-604.jpg?ga=GA1.1.363961418.1739264693&semt=ais_authors_boost" },
  { year: "2010", event: "Launched Our First Major Product.", image: "https://img.freepik.com/free-photo/view-building-construction_23-2147694702.jpg?ga=GA1.1.363961418.1739264693&semt=ais_authors_boost" },
  { year: "2015", event: "Global Recognition & Award.", image: "https://img.freepik.com/free-photo/3d-rendering-house-model_23-2150799663.jpg?ga=GA1.1.363961418.1739264693&semt=ais_authors_boost" },
  { year: "2020", event: "Adopted AI and Automation.", image: "https://img.freepik.com/free-photo/low-angle-view-skyscrapers_1359-604.jpg?ga=GA1.1.363961418.1739264693&semt=ais_authors_boost" },
  { year: "2024", event: "Leading the Industry with Innovation.", image: "https://img.freepik.com/free-photo/view-building-construction_23-2147694702.jpg?ga=GA1.1.363961418.1739264693&semt=ais_authors_boost" },
];

const CompanyHistory = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>
        Our Journey <span style={{ fontSize: "50px", color: "#5c0e14" }}>Since 1972</span>
      </h2>

      <div style={styles.timeline}>
        <div style={styles.timelineLine}></div>

        {historyData.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            style={{
              ...styles.historyItem,
              ...(index % 2 === 0
                ? styles.historyItemLeft
                : styles.historyItemRight),
            }}
          >
            <div style={styles.year}>{item.year}</div>
            <div style={styles.historyContent}>
              <img src={item.image} alt={item.year} style={styles.image} />
              <p style={styles.eventText}>{item.event}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

// Styles
const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    textAlign: "center",
    padding: "20px",
  },
  heading: {
    fontSize: "clamp(1.8rem, 3vw, 2.5rem)", // Responsive text size
    marginBottom: "30px",
  },
  timeline: {
    position: "relative",
    padding: "20px 0",
  },
  timelineLine: {
    position: "absolute",
    width: "4px",
    background: "#5c0e14",
    top: 0,
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
  },
  historyItem: {
    position: "relative",
    width: "45%",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  historyItemLeft: {
    textAlign: "right",
    left: "-5%",
  },
  historyItemRight: {
    textAlign: "left",
    left: "50%",
  },
  year: {
    fontSize: "clamp(1.2rem, 2vw, 1.5rem)",
    fontWeight: "bold",
    color: "#555",
    marginBottom: "10px",
  },
  historyContent: {
    background: "white",
    padding: "15px",
    borderRadius: "10px",
    fontSize: "clamp(0.8rem, 2vw, 1.2rem)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  image: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
  },
  eventText: {
    margin: 0,
  },
};

// Responsive Media Queries using JavaScript
const responsiveStyles = `
  @media (max-width: 768px) {
    .timeline-line {
      left: 4%;
    }
    .history-item {
      width: 80% !important;
      left: 5% !important;
      text-align: center !important;
      padding: 10px !important;
    }
    .history-content {
      flex-direction: column !important;
      text-align: center !important;
    }
  }
`;

// Injecting Responsive Styles
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerHTML = responsiveStyles;
document.head.appendChild(styleSheet);

export default CompanyHistory;
